module.exports = (s) => {
  return [
    {
      name: '时间',
      value: 'date',
      props: {
        width: 100,
        fixed: 'left',
      },
    },
    {
      name: '项目名称',
      value: 'project.name',
      props: {
        width: 100,
        fixed: 'left',
      },
    },
    {
      name: '广告名称',
      value: 'promotion.name',
      props: {
        width: 100,
        fixed: 'left',
      },
    },
    {
      name: '素材预览',
      align: 'center',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div', null, [
          h('material-preview', {
            props: {
              materialType: row.local_material_type,
              materialList: row.url,
            },
          }, ''),
        ]);
        return ele;
      },
    },
    {
      name: '素材ID',
      value: 'material_id',
    },
    {
      name: '素材库ID',
      value: 'local_material_id',
    },
    {
      name: '素材名称',
      value: 'local_material_name',
    },
    {
      name: '推广目的',
      value: 'landing_type',
      format: ({ landing_type }) => {
        return landing_type;
      },
    },
    {
      name: '转化目标',
      value: 'external_action',
      format: ({ external_action }) => {
        return s.$store.getters.jrttEnumVal.api_2_ad_convert_type[external_action];
      },
    },
    {
      name: '计费类型',
      value: 'pricing_type',
    },
    {
      name: '平台',
      value: 'platform',
      format: ({ platform }) => {
        return s.$store.getters.jrttEnumVal.api_2_platforms[platform];
      },
    },
  ];
};
